import React from 'react';
import SubBanner from '../components/SubBanner';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import WhyChooseUs from '../components/WhyChooseUs';
import Faq from '../components/Faq';
import CallToAction from '../components/CallToAction';

const ServicesPage = () => {
  return (
    <>
      <SubBanner title="Services" breadcrumb="Services" />
      <Features />
      <HowItWorks />
      <WhyChooseUs />
      <Faq />
      <CallToAction />
    </>
  );
};

export default ServicesPage;